import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import AddIcon from '@atlaskit/icon/core/add';
import { Flex, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	previewStyles: {
		width: '100%',
		backgroundColor: token('elevation.surface'),
		borderRadius: '5px',
		flex: 1,
	},
	previewHeaderStyles: {
		paddingBottom: token('space.300'),
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},
	previewContainerStyles: {
		paddingTop: token('space.300'),
		paddingRight: token('space.300'),
		paddingLeft: token('space.300'),
		paddingBottom: '0',
		width: '100%',
		flex: 1,
	},
});

const i18n = defineMessages({
	previewText: {
		id: 'smart-creation.preview.text',
		defaultMessage: 'Preview',
		description: 'Describes the preview area.',
	},
	previewButton: {
		id: 'smart-creation.preview.addToSpaceButton',
		defaultMessage: 'Add to space',
		description:
			'The button in the preview component for adding the preview content to current space.',
	},
});

export const PreviewContainer = () => {
	return (
		<Stack xcss={styles.previewContainerStyles}>
			<Flex xcss={styles.previewHeaderStyles}>
				<Text>
					<FormattedMessage {...i18n.previewText} />
				</Text>
				<Button appearance="primary" iconBefore={AddIcon}>
					<FormattedMessage {...i18n.previewButton} />
				</Button>
			</Flex>
			<Flex xcss={styles.previewStyles}> </Flex>
		</Stack>
	);
};
